const contacts = [{
        id: 1,
        name: "icon-button linkedin ",
        icon: "fab fa-linkedin-in fa-stack-1x fa-inverse",
        link: "https://www.linkedin.com/in/keerthana-palepu-217105219/"
    },
    {
        id: 2,
        name: "icon-button github",
        icon: "fa fa-github fa-stack-1x fa-inverse",
        link: "https://github.com/keerthanapalepu"
    },
    {
        id: 3,
        name: "icon-button instagram",
        icon: "fa fa-instagram fa-stack-1x fa-inverse",
        link: "https://www.instagram.com/known_75/"
    },
    {
        id: 4,
        name: "icon-button google",
        icon: "fa fa-envelope fa-stack-1x fa-inverse",
        link: "mailto:keerthanapalepu0810@gmail.com"
    },
    {
        id: 5,
        name: "icon-button twitter",
        icon: "fa fa-twitter fa-stack-1x fa-inverse ",
        link: "https://twitter.com/KeerthanaPalepu"
    }
];

export default contacts;